//Material UI Import
import {
  Button,
  CircularProgress,
  InputLabel,
  TextField,
  Typography,
} from "@material-ui/core";

//Translations
import { useTranslation } from "react-i18next";

//Redux
import {  useSelector } from "react-redux";
import { RootStore } from "../../../Store";

//Interface for the Props
interface PrizeNameEditModalProps {
  closeModal: () => void;
  newPrizeName:string;
  handlePrizeNameEdit:()=>void;
  handlePrizeNameChange:(event:any)=>void;
}

const PrizeNameEditModal: React.FC<PrizeNameEditModalProps> = ({
  closeModal,
  newPrizeName,
  handlePrizeNameEdit,
  handlePrizeNameChange
}) => {
  const [t] = useTranslation("global");

  //Redux State
  const prizesState = useSelector((state: RootStore) => state.prize);
  const loading = prizesState.loading;

  return(
    <div>
    <InputLabel style={{marginBottom:'20px'}}>
      <Typography variant="h5" color="primary">{t('prizes.edit-value')}:</Typography>
      </InputLabel>
      {t('prizes.new-prize-name')}
      <TextField type="text" name="name" value={newPrizeName} onChange={(event)=>{handlePrizeNameChange(event)}}/>
      <div style={{display:'flex', gap:'10px', marginTop:'10px'}}>
      <Button variant="contained" color="default" onClick={()=>{handlePrizeNameEdit()}} disabled={newPrizeName?.length<3}>
        {loading? 
        <CircularProgress/>:
        `${t('prizes.change')}` 
       }
      </Button>
      <Button variant="contained" color="default" onClick={closeModal}>{t('prizes.cancel')}</Button>
      </div>
    </div>
  )
};

export default PrizeNameEditModal;
